/**
 * Article Showcase — click a card to expand the full article in a modal.
 * Vanilla JS, no dependencies. Supports multiple showcase sections on one page.
 */
(function () {
  'use strict';

  function initShowcase(section) {
    var triggers = Array.prototype.slice.call(
      section.querySelectorAll('[data-article-trigger]')
    );
    if (!triggers.length) return;

    var modal = document.querySelector('[data-article-modal]');
    if (!modal) return;

    var contentEl = modal.querySelector('[data-article-modal-content]');
    var closeEls = modal.querySelectorAll('[data-article-close]');
    var lastFocusedTrigger = null;

    function open(index) {
      var template = section.querySelector(
        '[data-article-content="' + index + '"]'
      );
      if (!template) return;

      contentEl.innerHTML = '';
      contentEl.appendChild(template.content.cloneNode(true));

      lastFocusedTrigger = triggers[index];
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      contentEl.scrollTop = 0;

      var closeBtn = modal.querySelector('.article-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      contentEl.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocusedTrigger) lastFocusedTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = trigger.getAttribute('data-article-index');
        open(index);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.article-showcase');
    sections.forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.article-showcase');
    if (section) initShowcase(section);
  });
})();